import React from 'react';

import { makeStyles } from '@material-ui/core/styles';
import { GitHub, Twitter,Mail,PhoneAndroid, WhatsApp } from "@material-ui/icons"


const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    maxWidth: 752,
  },
  contact: {
   display:"flex",
   flexDirection:"row",
   flexWrap:"wrap",
   justifyContent:"center",
  },
   large: {
    width: theme.spacing(7),
    height: theme.spacing(7),
    position:"absolute",
    margin: theme.spacing(3, 0, 2,25),
  },

  title: {
    margin: theme.spacing(4, 0, 2),
  },
}));

export default function Contact() {
  const classes = useStyles();

  return (
    <div className={classes.root}>
          <div className={classes.contact}>
              <ul>
                <li> <Twitter/> </li>
                <li style={{fontWeight:"bolder", color:"blueviolet"}}>
                  <a href="https://twitter.com/_Qutekid">Twitter</a>
                </li>
              </ul>
              <ul>
                <li><PhoneAndroid/> </li>
                <li style={{fontWeight:"bolder", color:"red"}}>  Phone: <a href="tel:0740253367"> 0740253367</a> </li>
              </ul>
              <ul>
                <li> <WhatsApp/> </li>
                <li style={{fontWeight:"bolder", color:"#42f5ef"}}>
                  <a href="https://api.whatsapp.com/send?phone=+254740253367">WhatsApp </a>
                </li>
              </ul>
              <ul>
                <li> <Mail/> </li>
                <li style={{fontWeight:"bolder", color:"#f542a7"}}>
                  Email: <a href="mailto:kevinshikuku254@gmail.com">  kevinshikuku254@gmail.com </a>
                </li>
              </ul>
              <ul>
                <li> <GitHub/> </li>
                <li style={{fontWeight:"bolder", color:"#f542a7"}}>
                  GitHub: <a href="https://github.com/kevinsshikuku">  kevinshikuku </a>
                </li>
              </ul>

          </div>
    </div>
  );
}
